module.exports = __webpack_public_path__ + "static/img/jessecoffeesando.ce8c1b20.png";